import { useSelector } from 'react-redux';

import Global from '../../../../../store/global-selectors';
import { CardType } from '../types';
import type { CardData } from '../types';
import { getCardData } from '../services/card-data-service';
import { useOperationsCardsData } from '../contexts/operations-cards-data-context';

/**
 * Hook to get data for a specific card type
 * Consumes data from OperationsCardsDataProvider context
 * The provider handles all API calls and deduplication
 */
export const useCardData = (cardType: CardType): CardData => {
  const { statusCountMap, asyncCounts } = useOperationsCardsData();
  const returnsCountMap = useSelector(Global.selectReturnsNavStatusCountMap);
  const sellerTimeZone = useSelector(Global.selectSellerTimeZoneIANA);

  return getCardData(
    cardType,
    {
      statusCountMap,
      returnsCountMap,
      sellerTimeZone,
    },
    {
      oldestUnshipped: asyncCounts[CardType.UNSHIPPED_LAST_7_DAYS],
      shippedToday: asyncCounts[CardType.SHIPPED_TODAY],
      yesterdayUnshipped: asyncCounts[CardType.YESTERDAY_UNSHIPPED],
      pendingReturns: asyncCounts[CardType.PENDING_RETURNS],
      agingOrders7To30: asyncCounts[CardType.AGING_ORDERS_7_TO_30_DAYS],
    },
  );
};
